export const Tokens = [
  {
    "category": "Agreement",
    "token": "{d.Tenant.LeaseSignDate}",
    "label": "Lease Signed Date",
    "type": "token",
    "tooltip": "Date tenant signed lease"
  },
  {
    "category": "Auction",
    "token": "{d.Auction.CleaningDeposit}",
    "label": "Auction Cleaning Deposit",
    "type": "token",
    "tooltip": "Post-auction cleaning deposit"
  },
  {
    "category": "Auction",
    "token": "{d.Auction.EndDate}",
    "label": "Auction End Date",
    "type": "token",
    "tooltip": "Final auction date/time"
  },
  {
    "category": "Auction",
    "token": "{d.Auction.FinalBidAmt}",
    "label": "Auction Final Bid Amount",
    "type": "token",
    "tooltip": "Winning bid amount"
  },
  {
    "category": "Auction",
    "token": "{d.Auction.SaleDate}",
    "label": "Auction Sale Date",
    "type": "token",
    "tooltip": "Public auction date"
  },
  {
    "category": "Auction",
    "token": "{d.Auction.SaleDatePlus3}",
    "label": "Auction Sale Date +3",
    "type": "token",
    "tooltip": "Three days after auction date"
  },
  {
    "category": "Auction",
    "token": "{d.PostAuction.FinalBalDue}",
    "label": "Balance Due After Auction",
    "type": "token",
    "tooltip": "Remaining balance after auction"
  },
  {
    "category": "Auction",
    "token": "{d.Tenant.AuctionDate}",
    "label": "Auction Date",
    "type": "token",
    "tooltip": "Scheduled auction date"
  },
  {
    "category": "Auction",
    "token": "{d.Tenant.AuctionTime}",
    "label": "Auction Time",
    "type": "token",
    "tooltip": "Auction time of day"
  },
  {
    "category": "Billing and Delinquency",
    "token": "{d.Lease.DelinquencyDaysLate}",
    "label": "Delinquency Days Late",
    "type": "token",
    "tooltip": "Days payment is overdue"
  },
  {
    "category": "Billing and Delinquency",
    "token": "{d.Lease.DelinquencyStartDate}",
    "label": "Delinquency Start Date",
    "type": "token",
    "tooltip": "Date delinquency began"
  },
  {
    "category": "Billing and Delinquency",
    "token": "{d.Lease.PaymentCycle}",
    "label": "Payment Cycle",
    "type": "token",
    "tooltip": "How often rent is due"
  },
  {
    "category": "Billing and Delinquency",
    "token": "{d.Lease.PaymentCycleRent}",
    "label": "Rent Payment Cycle",
    "type": "token",
    "tooltip": "Rent payment frequency"
  },
  {
    "category": "Billing and Delinquency",
    "token": "{d.Space.Rent}",
    "label": "Space Rent",
    "type": "token",
    "tooltip": "Monthly rate for storage space"
  },
  {
    "category": "Billing and Delinquency",
    "token": "{d.Tenant.TotalDue}",
    "label": "Total Rent Due",
    "type": "token",
    "tooltip": "Total amount owed"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.CardBusinessName}",
    "label": "Credit Card Business Name",
    "type": "token",
    "tooltip": "Business name on card"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.CardExpDate}",
    "label": "Credit Card Expiration Date",
    "type": "token",
    "tooltip": "Card expiration date"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.CardName}",
    "label": "Credit Card Holder Name",
    "type": "token",
    "tooltip": "Name on credit card"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.CardNumber}",
    "label": "Credit Card Number",
    "type": "token",
    "tooltip": "Full credit card number"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.CardType}",
    "label": "Credit Card Type",
    "type": "token",
    "tooltip": "Credit card type"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.CardType}",
    "label": "Credit Card Type",
    "type": "token"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.CCLast4}",
    "label": "Last 4 Digits of Credit Card",
    "type": "token",
    "tooltip": "Last 4 digits of card"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.CellPhone}",
    "label": "Tenant Cell Phone",
    "type": "token",
    "tooltip": "Tenant's mobile phone"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.City}",
    "label": "Tenant City",
    "type": "token",
    "tooltip": "Tenant's city"
  },
  {
    "category": "Billing and Delinquency",
    "token": "{d.Tenant.MonthlyCharge}",
    "label": "Monthly Charge",
    "type": "token",
    "tooltip": "Regular monthly rental amount"
  },
  {
    "category": "Billing and Delinquency",
    "token": "{d.Tenant.MonthlyCost}",
    "label": "Monthly Cost",
    "type": "token",
    "tooltip": "Total monthly cost with fees"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.BusinessName}",
    "label": "Business Name",
    "type": "token",
    "tooltip": "Official business name"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.BusinessRepresentativeAddress1}",
    "label": "Business Representative Address Line 1",
    "type": "token",
    "tooltip": "Business rep primary address"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.BusinessRepresentativeAddress2}",
    "label": "Business Representative Address Line 2",
    "type": "token",
    "tooltip": "Business rep secondary address"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.BusinessRepresentativeCity}",
    "label": "Business Representative City",
    "type": "token",
    "tooltip": "Business rep city"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.BusinessRepresentativeCountry}",
    "label": "Business Representative Country",
    "type": "token",
    "tooltip": "Business rep country"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.BusinessRepresentativeEmail}",
    "label": "Business Representative Email",
    "type": "token",
    "tooltip": "Business rep email"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.BusinessRepresentativeName}",
    "label": "Business Representative Name",
    "type": "token",
    "tooltip": "Business representative name"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.BusinessRepresentativePhone}",
    "label": "Business Representative Phone Number",
    "type": "token",
    "tooltip": "Business rep phone"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.BusinessRepresentativePostalCode}",
    "label": "Business Representative Postal Code",
    "type": "token",
    "tooltip": "Business rep postal code"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.BusinessRepresentativeState}",
    "label": "Business Representative State",
    "type": "token",
    "tooltip": "Business rep state"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.Company}",
    "label": "Company Name",
    "type": "token",
    "tooltip": "Company name"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.CompanyCity}",
    "label": "Business City",
    "type": "token",
    "tooltip": "Company city"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.CompanyEmail}",
    "label": "Business Email",
    "type": "token",
    "tooltip": "Company email"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.CompanyAddress1}",
    "label": "Business Address Line 1",
    "type": "token",
    "tooltip": "Company primary address"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.CompanyAddress2}",
    "label": "Business Address Line 2",
    "type": "token",
    "tooltip": "Company secondary address"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.CompanyCountry}",
    "label": "Business Country",
    "type": "token",
    "tooltip": "Company country"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.CompanyPostalCode}",
    "label": "Business Postal Code",
    "type": "token",
    "tooltip": "Company postal code"
  },
  {
    "category": "Business Tenant",
    "token": "{d.Tenant.CompanyState}",
    "label": "Business State",
    "type": "token",
    "tooltip": "Company state"
  },
  {
    "category": "Coverage and Insurance",
    "token": "{d.Tenant.InsuranceCompanyName}",
    "label": "Tenant Insurance Name",
    "type": "token",
    "tooltip": "Insurance company name"
  },
  {
    "category": "Coverage and Insurance",
    "token": "{d.Tenant.InsuranceExpDate}",
    "label": "Tenant Insurance Expiration Date",
    "type": "token",
    "tooltip": "Insurance expiration date"
  },
  {
    "category": "Coverage and Insurance",
    "token": "{d.Tenant.InsurancePolicyNo}",
    "label": "Tenant Insurance Policy Number",
    "type": "token",
    "tooltip": "Insurance policy number"
  },
  {
    "category": "Coverage and Insurance",
    "token": "{d.Tenant.InsurancePremium}",
    "label": "Tenant Insurance Premium",
    "type": "token",
    "tooltip": "Insurance premium amount"
  },
  {
    "category": "Document Info",
    "token": "{d.Document.Date}",
    "label": "Document Created Date",
    "type": "token",
    "tooltip": "Date document was generated"
  },
  {
    "category": "Document Info",
    "token": "{d.Document.Time}",
    "label": "Document Created Time",
    "type": "token",
    "tooltip": "Time document was created"
  },
  {
    "category": "Property",
    "token": "{d.Facility.Address1}",
    "label": "Property Address Line 1",
    "type": "token",
    "tooltip": "Primary property address"
  },
  {
    "category": "Property",
    "token": "{d.Facility.Address2}",
    "label": "Property Address Line 2",
    "type": "token",
    "tooltip": "Secondary address line"
  },
  {
    "category": "Property",
    "token": "{d.Facility.AdvertisingFee}",
    "label": "Property Advertising Fee",
    "type": "token",
    "tooltip": "Auction advertising fee"
  },
  {
    "category": "Property",
    "token": "{d.Facility.AfterHoursPhone}",
    "label": "Property After-Hours Phone Number",
    "type": "token",
    "tooltip": "After-hours contact number"
  },
  {
    "category": "Property",
    "token": "{d.Facility.City}",
    "label": "Property City",
    "type": "token",
    "tooltip": "Property city"
  },
  {
    "category": "Property",
    "token": "{d.Facility.CleaningFee}",
    "label": "Property Cleaning Fee",
    "type": "token",
    "tooltip": "Unit cleaning fee"
  },
  {
    "category": "Property",
    "token": "{d.Facility.Country}",
    "label": "Property Country",
    "type": "token",
    "tooltip": "Property country"
  },
  {
    "category": "Property",
    "token": "{d.Facility.Email}",
    "label": "Property Email Address",
    "type": "token",
    "tooltip": "Property email"
  },
  {
    "category": "Property",
    "token": "{d.Facility.KeyDepositFee}",
    "label": "Property Deposit Fee",
    "type": "token",
    "tooltip": "Key/access deposit fee"
  },
  {
    "category": "Property",
    "token": "{d.Facility.LateFee}",
    "label": "Property Late Fee",
    "type": "token",
    "tooltip": "Late payment fee"
  },
  {
    "category": "Property",
    "token": "{d.Facility.NsfFee}",
    "label": "Property NSF Fee",
    "type": "token",
    "tooltip": "Non-sufficient funds fee"
  },
  {
    "category": "Property",
    "token": "{d.Facility.NsfFee}",
    "label": "Property NSF Fee",
    "type": "token"
  },
  {
    "category": "Property",
    "token": "{d.Facility.LegalName}",
    "label": "Property Legal Name",
    "type": "token",
    "tooltip": "Official business name"
  },
  {
    "category": "Property",
    "token": "{d.Facility.LienNoticeFee}",
    "label": "Property Lien Notice Fee",
    "type": "token",
    "tooltip": "Lien notice filing fee"
  },
  {
    "category": "Property",
    "token": "{d.Facility.LienSaleChargeFee}",
    "label": "Property Lien Sale Charge Fee",
    "type": "token",
    "tooltip": "Lien sale additional charges"
  },
  {
    "category": "Property",
    "token": "{d.Facility.LienSaleFee}",
    "label": "Property Lien Sale Fee",
    "type": "token",
    "tooltip": "Base lien sale fee"
  },
  {
    "category": "Property",
    "token": "{d.Facility.LockCutFee}",
    "label": "Property Lock Cut Fee",
    "type": "token",
    "tooltip": "Lock cutting fee"
  },
  {
    "category": "Property",
    "token": "{d.Facility.Name}",
    "label": "Property Name",
    "type": "token",
    "tooltip": "Common business name"
  },
  {
    "category": "Property",
    "token": "{d.Facility.NoticeOfLienSaleFee}",
    "label": "Property Notice of Lien Sale Fee",
    "type": "token",
    "tooltip": "Lien sale notice fee"
  },
  {
    "category": "Property",
    "token": "{d.Facility.Phone}",
    "label": "Property Phone Number",
    "type": "token",
    "tooltip": "Main property phone"
  },
  {
    "category": "Property",
    "token": "{d.Facility.PostalCode}",
    "label": "Property Postal Code",
    "type": "token",
    "tooltip": "Property postal code"
  },
  {
    "category": "Property",
    "token": "{d.Facility.PublicAuctionFee}",
    "label": "Property Public Auction Fee",
    "type": "token",
    "tooltip": "Public auction service fee"
  },
  {
    "category": "Property",
    "token": "{d.Facility.SalesTax}",
    "label": "Property Sales Tax",
    "type": "token",
    "tooltip": "Local tax rate"
  },
  {
    "category": "Property",
    "token": "{d.Facility.SecurityDeposit}",
    "label": "Property Security Deposit",
    "type": "token",
    "tooltip": "Security deposit amount"
  },
  {
    "category": "Property",
    "token": "{d.Facility.State}",
    "label": "Property State",
    "type": "token",
    "tooltip": "Property state"
  },
  {
    "category": "Property",
    "token": "{d.Facility.UnitSize}",
    "label": "Property Unit Size",
    "type": "token",
    "tooltip": "Storage space dimensions"
  },
  {
    "category": "Property",
    "token": "{d.Facility.UnitType}",
    "label": "Property Unit Type",
    "type": "token",
    "tooltip": "Type of storage space"
  },
  {
    "category": "Property",
    "token": "{d.Facility.Website}",
    "label": "Property Website",
    "type": "token",
    "tooltip": "Property website"
  },
  {
    "category": "Property",
    "token": "{d.Facility.Zipcode}",
    "label": "Property Zip Code",
    "type": "token",
    "tooltip": "Property zip code"
  },
  {
    "category": "Coverage and Insurance",
    "token": "{d.Insurance.PremiumCoverage}",
    "label": "Tenant Insurange Premium Coverage",
    "type": "token",
    "tooltip": "What premium covers"
  },
  {
    "category": "Coverage and Insurance",
    "token": "{d.Insurance.ServiceStartDate}",
    "label": "Tenant Insurance Start Date",
    "type": "token",
    "tooltip": "Insurance coverage start date"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.MoveInDate}",
    "label": "Move-In Date",
    "type": "token",
    "tooltip": "Date tenant moved in"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.MoveInDiscount}",
    "label": "Move-In Discount",
    "type": "token",
    "tooltip": "Move-in discount amount"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.MoveOutDate}",
    "label": "Move-out Date",
    "type": "token",
    "tooltip": "Date tenant is moving out"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.NewMonthlyCharge}",
    "label": "New Monthly Charge",
    "type": "token",
    "tooltip": "Updated monthly rent"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.NewRate}",
    "label": "New Rate",
    "type": "token",
    "tooltip": "New rental rate"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.NewRateDate}",
    "label": "New Rate Date",
    "type": "token",
    "tooltip": "Date new rate takes effect"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.NewRentWithTax}",
    "label": "New Rent with Tax",
    "type": "token",
    "tooltip": "New rent including taxes"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.NextRentDueDate}",
    "label": "Next Rent Due Date",
    "type": "token",
    "tooltip": "Next payment due date"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.RentDueDate}",
    "label": "Rent Due Date",
    "type": "token",
    "tooltip": "Rent due date"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.RentDueDate}",
    "label": "Rent Due Date",
    "type": "token"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.PayLink}",
    "label": "Payment Link",
    "type": "token",
    "tooltip": "Online payment URL"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.Promo}",
    "label": "Promotional Name",
    "type": "token",
    "tooltip": "Applied promo name"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.ProratedInsurancePremium}",
    "label": "Prorated Insurance Premium",
    "type": "token",
    "tooltip": "Partial month insurance cost"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.ProratedRent}",
    "label": "Prorated Rent",
    "type": "token",
    "tooltip": "Partial month rent"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.PTDPlus1}",
    "label": "Past Due Date Plus 1",
    "type": "token",
    "tooltip": "Day after past due date"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.RentPaidThruDate}",
    "label": "Rent Paid Through Date",
    "type": "token",
    "tooltip": "Last date rent covers"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.RentPastDueDays}",
    "label": "Rent Past Due Days",
    "type": "token",
    "tooltip": "Days rent is overdue"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.RentWithTax}",
    "label": "Rent with Tax Included",
    "type": "token",
    "tooltip": "Total rent with taxes"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.StoredContents}",
    "label": "Stored Contents Description",
    "type": "token",
    "tooltip": "Description of stored items"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.TotalMoveInCost}",
    "label": "Total Move-In Cost",
    "type": "token",
    "tooltip": "Total amount due at move-in"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.Lien.No}",
    "label": "No Lien",
    "type": "token",
    "tooltip": "Indicates no lien exists"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.Lien.Yes}",
    "label": "Has Lien",
    "type": "token",
    "tooltip": "Indicates lien exists"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.LienHolderAddress1}",
    "label": "Lienholder Address Line 1",
    "type": "token",
    "tooltip": "Lienholder primary address"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.LienHolderAddress2}",
    "label": "Lienholder Address Line 2",
    "type": "token",
    "tooltip": "Lienholder secondary address"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.LienHolderCity}",
    "label": "Lienholder City",
    "type": "token",
    "tooltip": "Lienholder city"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.LienHolderCountry}",
    "label": "Lienholder Country",
    "type": "token",
    "tooltip": "Lienholder country"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.LienHolderEmail}",
    "label": "Lienholder Email",
    "type": "token",
    "tooltip": "Lienholder email"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.LienHolderFirstName}",
    "label": "Lienholder First Name",
    "type": "token",
    "tooltip": "Lienholder first name"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.LienHolderLastName}",
    "label": "Lienholder Last Name",
    "type": "token",
    "tooltip": "Lienholder last name"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.LienHolderName}",
    "label": "Lienholder Name",
    "type": "token",
    "tooltip": "Full lienholder name"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.LienHolderPhone}",
    "label": "Lienholder Phone Number",
    "type": "token",
    "tooltip": "Lienholder phone"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.LienHolderPostalCode}",
    "label": "Lienholder Postal Code",
    "type": "token",
    "tooltip": "Lienholder postal code"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.LienHolderState}",
    "label": "Lienholder State",
    "type": "token",
    "tooltip": "Lienholder state"
  },
  {
    "category": "Lienholder",
    "token": "{d.Tenant.LienProperty}",
    "label": "Lien Property",
    "type": "token",
    "tooltip": "Property subject to lien"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryAddress1}",
    "label": "Military Address Line 1",
    "type": "token",
    "tooltip": "Primary military address"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryAddress2}",
    "label": "Military Address Line 2",
    "type": "token",
    "tooltip": "Secondary military address"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryBranchName}",
    "label": "Military Branch Name",
    "type": "token",
    "tooltip": "Branch of service"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryCity}",
    "label": "Military City",
    "type": "token",
    "tooltip": "Military base city"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryContactEmail}",
    "label": "Military Contact Email",
    "type": "token",
    "tooltip": "Military email contact"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryContactPhone}",
    "label": "Military Contact Phone Number",
    "type": "token",
    "tooltip": "Military phone number"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryCountry}",
    "label": "Military Country ",
    "type": "token",
    "tooltip": "Country of service"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryEmail}",
    "label": "Military Email",
    "type": "token",
    "tooltip": "Military email address"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryETSDate}",
    "label": "Military Service Expiration",
    "type": "token",
    "tooltip": "End of service date"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryID}",
    "label": "Military ID",
    "type": "token",
    "tooltip": "Military ID number"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryPhone}",
    "label": "Military Phone Number",
    "type": "token",
    "tooltip": "Military phone"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryPostalCode}",
    "label": "Military Postal Code",
    "type": "token",
    "tooltip": "Military postal code"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryRank}",
    "label": "Military Rank",
    "type": "token",
    "tooltip": "Service member rank"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryState}",
    "label": "Military State",
    "type": "token",
    "tooltip": "Military base state"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.MilitaryUnitName}",
    "label": "Military Unit Name",
    "type": "token",
    "tooltip": "Military unit name"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.ServicememberName}",
    "label": "Servicemember Name",
    "type": "token",
    "tooltip": "Service member name"
  },
  {
    "category": "Recipient",
    "token": "{d.Recipient.address}",
    "label": "Recipient Address Line 1",
    "type": "token",
    "tooltip": "Document recipient address"
  },
  {
    "category": "Recipient",
    "token": "{d.Recipient.address2}",
    "label": "Recipient Address Line 2",
    "type": "token",
    "tooltip": "Recipient secondary address"
  },
  {
    "category": "Recipient",
    "token": "{d.Recipient.country}",
    "label": "Recipient Country",
    "type": "token",
    "tooltip": "Recipient country"
  },
  {
    "category": "Recipient",
    "token": "{d.Recipient.name}",
    "label": "Recipient Name",
    "type": "token",
    "tooltip": "Document recipient name"
  },
  {
    "category": "Recipient",
    "token": "{d.Recipient.PostalCode}",
    "label": "Recipient Postal Code",
    "type": "token",
    "tooltip": "Recipient postal code"
  },
  {
    "category": "Recipient",
    "token": "{d.Recipient.state}",
    "label": "Recipient State",
    "type": "token",
    "tooltip": "Recipient state"
  },
  {
    "category": "Space",
    "token": "{d.ReversalSpace.ID}",
    "label": "Reversal Space ID",
    "type": "token",
    "tooltip": "ID of reversed space"
  },
  {
    "category": "Space",
    "token": "{d.Space.ID}",
    "label": "Space ID",
    "type": "token",
    "tooltip": "Storage space identifier"
  },
  {
    "category": "Space",
    "token": "{d.Space.Rate}",
    "label": "Space Rate",
    "type": "token",
    "tooltip": "Monthly rate for storage space"
  },
  {
    "category": "Space",
    "token": "{d.Space.Size}",
    "label": "Space Size",
    "type": "token",
    "tooltip": "Storage space dimensions"
  },
  {
    "category": "Space",
    "token": "{d.Space.Type}",
    "label": "Space Type",
    "type": "token",
    "tooltip": "Type of storage space"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Storing.SensitiveData}",
    "label": "Storing Sensitive Data",
    "type": "token",
    "tooltip": "Sensitive data storage indicator"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.Access1Name}",
    "label": "Authorized Access Person Name",
    "type": "token",
    "tooltip": "Name of authorized person"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.Access1Phone}",
    "label": "Authorized Access Person Phone",
    "type": "token",
    "tooltip": "Authorized person phone"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.AccountType}",
    "label": "Tenant Account Type",
    "type": "token",
    "tooltip": "Type of rental account"
  },
  {
    "category": "Military Info",
    "token": "{d.Tenant.ActiveMilitary}",
    "label": "Military Status",
    "type": "token",
    "tooltip": "Current military status"
  },
  {
    "category": "Alternate Contact",
    "token": "{d.Tenant.AuthorizedAccessPersons}",
    "label": "Authorized Access Persons",
    "type": "token",
    "tooltip": "People authorized to access unit"
  },
  {
    "category": "Lease",
    "token": "{d.Tenant.Discount}",
    "label": "Discount Name",
    "type": "token",
    "tooltip": "Applied discount name"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.DLExpDate}",
    "label": "Driver License Expiration Date",
    "type": "token",
    "tooltip": "License expiration date"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.DLNumber}",
    "label": "Driver License Number",
    "type": "token",
    "tooltip": "Driver's license number"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.DLProvince}",
    "label": "Driver License Province",
    "type": "token",
    "tooltip": "License issuing province"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.DLState}",
    "label": "Driver License State",
    "type": "token",
    "tooltip": "License issuing state"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.FirstName}",
    "label": "Tenant First Name",
    "type": "token",
    "tooltip": "Tenant's first name"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.GateCode}",
    "label": "Gate Code",
    "type": "token",
    "tooltip": "Gate access code"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.LastName}",
    "label": "Tenant Last Name",
    "type": "token",
    "tooltip": "Tenant's last name"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.Title}",
    "label": "Tenant Title",
    "type": "token",
    "tooltip": "Mr., Mrs., Dr., etc."
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.BankAccountNum}",
    "label": "Bank Account Number",
    "type": "token",
    "tooltip": "Bank account for auto-pay"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.BankCity}",
    "label": "Bank City",
    "type": "token",
    "tooltip": "Bank location city"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.BankPostalCode}",
    "label": "Bank Postal Code",
    "type": "token",
    "tooltip": "Bank postal code"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.BankRoutingNum}",
    "label": "Routing Number",
    "type": "token",
    "tooltip": "Bank routing number"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.BankState}",
    "label": "Bank State",
    "type": "token",
    "tooltip": "Bank location state"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.BillingAddress1}",
    "label": "Billing Address Line 1",
    "type": "token",
    "tooltip": "Primary billing address"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.BillingAddress2}",
    "label": "Billing Address Line 2",
    "type": "token",
    "tooltip": "Secondary billing address"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.BillingCity}",
    "label": "Billing City",
    "type": "token",
    "tooltip": "Billing address city"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.BillingCountry}",
    "label": "Billing Country",
    "type": "token",
    "tooltip": "Billing address country"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.BillingPostalCode}",
    "label": "Billing Postal Code",
    "type": "token",
    "tooltip": "Billing postal code"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.BillingState}",
    "label": "Billing State",
    "type": "token",
    "tooltip": "Billing address state"
  },
  {
    "category": "Tenant Billing Info",
    "token": "{d.Tenant.TaxpayerID}",
    "label": "Taxpayer Number",
    "type": "token",
    "tooltip": "Tax identification number"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.Address1}",
    "label": "Tenant Address Line 1",
    "type": "token",
    "tooltip": "Primary tenant address"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.Address2}",
    "label": "Tenant Address Line 2",
    "type": "token",
    "tooltip": "Secondary tenant address"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AdminFee}",
    "label": "Tenant Admin Fee",
    "type": "token",
    "tooltip": "Administrative fee"
  },
  {
    "category": "Property Info",
    "token": "{d.Facility.AdminFee}",
    "label": "Property Admin Fee",
    "type": "token",
    "tooltip": "Property administrative fee"
  },
  {
    "category": "Property Info",
    "token": "{d.Facility.AdminFee}",
    "label": "Property Admin Fee",
    "type": "token"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AltAddress1}",
    "label": "Alternative Address Line 1",
    "type": "token",
    "tooltip": "Alt contact primary address"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AltAddress2}",
    "label": "Alternative Address Line 2",
    "type": "token",
    "tooltip": "Alt contact secondary address"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AltCellPhone}",
    "label": "Alternative Cell Phone",
    "type": "token",
    "tooltip": "Alt contact mobile phone"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AltCity}",
    "label": "Alternative City",
    "type": "token",
    "tooltip": "Alt contact city"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AltCountry}",
    "label": "Alternative Country",
    "type": "token",
    "tooltip": "Alt contact country"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AltEmail}",
    "label": "Alternative Email",
    "type": "token",
    "tooltip": "Alt contact email"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AltHomePhone}",
    "label": "Alternative Home Phone",
    "type": "token",
    "tooltip": "Alt contact home phone"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AltName}",
    "label": "Alternative Name",
    "type": "token",
    "tooltip": "Alt contact name"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AltPhone}",
    "label": "Alternative Phone Number",
    "type": "token",
    "tooltip": "Alt contact phone"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AltPostalCode}",
    "label": "Alternative Postal Code",
    "type": "token",
    "tooltip": "Alt contact postal code"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AltState}",
    "label": "Alternative State",
    "type": "token",
    "tooltip": "Alt contact state"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.AltWorkPhone}",
    "label": "Alternative Work Phone",
    "type": "token",
    "tooltip": "Alt contact work phone"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.Country}",
    "label": "Tenant Country",
    "type": "token",
    "tooltip": "Tenant's country"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.HomePhone}",
    "label": "Tenant Home Phone",
    "type": "token",
    "tooltip": "Tenant's home phone"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.Name}",
    "label": "Tenant Name",
    "type": "token",
    "tooltip": "Full tenant name"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.Phone}",
    "label": "Tenant Phone Number",
    "type": "token",
    "tooltip": "Primary tenant phone"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.PostalCode}",
    "label": "Tenant Postal Code",
    "type": "token",
    "tooltip": "Tenant's postal code"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.SSN}",
    "label": "Tenant Social Security Number",
    "type": "token",
    "tooltip": "Tenant's SSN"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.State}",
    "label": "Tenant State",
    "type": "token",
    "tooltip": "Tenant's state"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.Email}",
    "label": "Tenant Email",
    "type": "token",
    "tooltip": "Tenant's email address"
  },
  {
    "category": "Tenant Employer",
    "token": "{d.Tenant.EmployerAddress1}",
    "label": "Employer Address Line 1",
    "type": "token",
    "tooltip": "Employer primary address"
  },
  {
    "category": "Tenant Employer",
    "token": "{d.Tenant.EmployerAddress2}",
    "label": "Employer Address Line 2",
    "type": "token",
    "tooltip": "Employer secondary address"
  },
  {
    "category": "Tenant Employer",
    "token": "{d.Tenant.EmployerCellPhone}",
    "label": "Employer Cell Phone",
    "type": "token",
    "tooltip": "Employer cell phone"
  },
  {
    "category": "Tenant Employer",
    "token": "{d.Tenant.EmployerCity}",
    "label": "Tenant Employer City",
    "type": "token",
    "tooltip": "Employer city"
  },
  {
    "category": "Tenant Employer",
    "token": "{d.Tenant.EmployerCountry}",
    "label": "Tenant Employer Country",
    "type": "token",
    "tooltip": "Employer country"
  },
  {
    "category": "Tenant Employer",
    "token": "{d.Tenant.EmployerName}",
    "label": "Tenant Employer Name",
    "type": "token",
    "tooltip": "Employer name"
  },
  {
    "category": "Tenant Employer",
    "token": "{d.Tenant.EmployerPostalCode}",
    "label": "Tenant Employer Postal Code",
    "type": "token",
    "tooltip": "Employer postal code"
  },
  {
    "category": "Tenant Employer",
    "token": "{d.Tenant.EmployerState}",
    "label": "Tenant Employer State",
    "type": "token",
    "tooltip": "Employer state"
  },
  {
    "category": "Tenant Employer",
    "token": "{d.Tenant.EmployerWorkPhone}",
    "label": "Tenant Employer Work Phone",
    "type": "token",
    "tooltip": "Employer work phone"
  },
  {
    "category": "Tenant Contact Info",
    "token": "{d.Tenant.WorkPhone}",
    "label": "Tenant Work Phone",
    "type": "token",
    "tooltip": "Tenant's work phone"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.BoatHomePort}",
    "label": "Boat Home Port",
    "type": "token",
    "tooltip": "Boat's home port"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.BoatHorsePower}",
    "label": "Boat Horse Power",
    "type": "token",
    "tooltip": "Boat engine horsepower"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.BoatLength}",
    "label": "Boat Length",
    "type": "token",
    "tooltip": "Length of boat"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.BoatName}",
    "label": "Boat Name",
    "type": "token",
    "tooltip": "Name of boat"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.BoatRegistrationNo}",
    "label": "Boat Registration Number",
    "type": "token",
    "tooltip": "Boat registration number"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.BoatSerialNo}",
    "label": "Booat Serial Number",
    "type": "token",
    "tooltip": "Boat serial number"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.MotorDocumentNo}",
    "label": "Motor Document Number",
    "type": "token",
    "tooltip": "Motor documentation number"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.MotorManufacturer}",
    "label": "Motor Manufacturer",
    "type": "token",
    "tooltip": "Motor manufacturer"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.MotorVINNo}",
    "label": "Motor VIN Number",
    "type": "token",
    "tooltip": "Motor VIN"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.MotorYear}",
    "label": "Motor Year",
    "type": "token",
    "tooltip": "Motor manufacture year"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.StoreVehicleNo}",
    "label": "Tenant Is Not Storing A Vehicle",
    "type": "token",
    "tooltip": "No vehicle stored"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.StoreVehicleYes}",
    "label": "Tenant Is Storing A Vehicle",
    "type": "token",
    "tooltip": "Vehicle is stored"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.TrailerApproxValue}",
    "label": "Trailer Approximate Value",
    "type": "token",
    "tooltip": "Estimated trailer value"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.TrailerExpiration}",
    "label": "Trailer Registration Expiration Date",
    "type": "token",
    "tooltip": "Trailer registration expires"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.TrailerInsPolicyNumber}",
    "label": "Trailer Insurance Policy Number",
    "type": "token",
    "tooltip": "Trailer insurance policy"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.TrailerInsuranceProvider}",
    "label": "Trailer Insurance Provider",
    "type": "token",
    "tooltip": "Trailer insurance company"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.TrailerLicensePlateNo}",
    "label": "Trailer License Plate Number",
    "type": "token",
    "tooltip": "Trailer license plate"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.TrailerRegistrationCountry}",
    "label": "Trailer Registration Country",
    "type": "token",
    "tooltip": "Trailer registration country"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.TrailerRegistrationState}",
    "label": "Trailer Registration State",
    "type": "token",
    "tooltip": "Trailer registration state"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.TrailerVIN}",
    "label": "Trailer VIN",
    "type": "token",
    "tooltip": "Trailer VIN number"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleApproxValue}",
    "label": "Vehicle Approximate Value",
    "type": "token",
    "tooltip": "Estimated vehicle value"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleBoatYes}",
    "label": "Tenant Is Storing A Boat",
    "type": "token",
    "tooltip": "Boat is stored"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleCarYes}",
    "label": "Tenant Is Storing A Car",
    "type": "token",
    "tooltip": "Car is stored"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleExpiration}",
    "label": "Vehicle Registration Expiration Date",
    "type": "token",
    "tooltip": "Vehicle registration expires"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleInsProvider}",
    "label": "Vehicle Insurance Provider",
    "type": "token",
    "tooltip": "Vehicle insurance company"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleLicPlateNo}",
    "label": "Vehicle License Plate Number",
    "type": "token",
    "tooltip": "Vehicle license plate"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleLienHolderDetails}",
    "label": "Vehicle Lien Holder Details",
    "type": "token",
    "tooltip": "Vehicle lienholder info"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleMotorcycleYes}",
    "label": "Tenant Is Storing A Motorcycle",
    "type": "token",
    "tooltip": "Motorcycle is stored"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleMotorYes}",
    "label": "Tenant Is Storing A Motor",
    "type": "token",
    "tooltip": "Motor is stored"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleOtherYes}",
    "label": "Tenant Storing Another Type of Vehicle",
    "type": "token",
    "tooltip": "Other vehicle type stored"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehiclePolicyNumber}",
    "label": "Vehicle Insurance Policy Number",
    "type": "token",
    "tooltip": "Vehicle insurance policy"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleRecreationalYes}",
    "label": "Tenant Storing A Recreational Vehicle",
    "type": "token",
    "tooltip": "RV is stored"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleRegCountry}",
    "label": "Vehicle Registration Country",
    "type": "token",
    "tooltip": "Vehicle registration country"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleRegState}",
    "label": "Vehicle Registration State",
    "type": "token",
    "tooltip": "Vehicle registration state"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleTrailerLicense}",
    "label": "Vehicle Trailer License",
    "type": "token",
    "tooltip": "Vehicle trailer license"
  },
  {
    "category": "Vehicle",
    "token": "{d.Tenant.VehicleTrailerYes}",
    "label": "Tenant Is Storing A Trailer",
    "type": "token",
    "tooltip": "Trailer is stored"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.ApproxValue}",
    "label": "Vehicle Approximate Value",
    "type": "token",
    "tooltip": "Estimated vehicle value"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.Color}",
    "label": "Vehicle Color",
    "type": "token",
    "tooltip": "Vehicle color"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.InsuranceProvider}",
    "label": "Vehicle Insurance Provider",
    "type": "token",
    "tooltip": "Vehicle insurance company"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.LegalOwnerAddress1}",
    "label": "Vehicle Legal Owner Address Line 1",
    "type": "token",
    "tooltip": "Legal owner primary address"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.LegalOwnerAddress2}",
    "label": "Vehicle Legal Owner Address Line 2",
    "type": "token",
    "tooltip": "Legal owner secondary address"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.LegalOwnerCity}",
    "label": "Vehicle Legal Owner City",
    "type": "token",
    "tooltip": "Legal owner city"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.LegalOwnerCountry}",
    "label": "Vehicle Legal Owner Country",
    "type": "token",
    "tooltip": "Legal owner country"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.LegalOwnerName}",
    "label": "Vehicle Legal Owner Name",
    "type": "token",
    "tooltip": "Legal owner name"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.LegalOwnerPostalCode}",
    "label": "Vehicle Legal Owner Postal Code",
    "type": "token",
    "tooltip": "Legal owner postal code"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.LegalOwnerState}",
    "label": "Vehicle Legal Owner State",
    "type": "token",
    "tooltip": "Legal owner state"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.LicensePlateNo}",
    "label": "License Plate Number",
    "type": "token",
    "tooltip": "License plate number"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.Make}",
    "label": "Vehicle Make",
    "type": "token",
    "tooltip": "Vehicle manufacturer"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.Manufacturer}",
    "label": "Vehicle Manufacturer",
    "type": "token",
    "tooltip": "Vehicle manufacturer name"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.Model}",
    "label": "Vehicle Model",
    "type": "token",
    "tooltip": "Vehicle model name"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.RegOwnerAddress1}",
    "label": "Vehicle Registered Owner Address Line 1",
    "type": "token",
    "tooltip": "Registered owner primary address"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.RegOwnerAddress2}",
    "label": "Vehicle Registered Owner Address Line 2",
    "type": "token",
    "tooltip": "Registered owner secondary address"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.RegOwnerCity}",
    "label": "Vehicle Registered Owner City",
    "type": "token",
    "tooltip": "Registered owner city"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.RegOwnerCountry}",
    "label": "Vehicle Registered Owner Country",
    "type": "token",
    "tooltip": "Registered owner country"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.RegOwnerName}",
    "label": "Vehicle Registered Owner Name",
    "type": "token",
    "tooltip": "Registered owner name"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.RegOwnerPostalCode}",
    "label": "Vehicle Registered Owner Postal Code",
    "type": "token",
    "tooltip": "Registered owner postal code"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.RegOwnerState}",
    "label": "Vehicle Registered Owner State",
    "type": "token",
    "tooltip": "Registered owner state"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.RegState}",
    "label": "Vehicle Registration State",
    "type": "token",
    "tooltip": "Vehicle registration state"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.VIN}",
    "label": "Vehicle VIN",
    "type": "token",
    "tooltip": "Vehicle VIN number"
  },
  {
    "category": "Vehicle",
    "token": "{d.Vehicle.Year}",
    "label": "Vehicle Year",
    "type": "token",
    "tooltip": "Vehicle manufacture year"
  },
  {
    "category": "Property Info",
    "token": "{d.Facility.OfficeHours}",
    "label": "Property Office Hours",
    "type": "token",
    "tooltip": "Property office hours"
  },
  {
    "category": "Property Info",
    "token": "{d.Facility.GateHours}",
    "label": "Property Gate Hours",
    "type": "token",
    "tooltip": "Property gate access hours"
  },
  {
    "label": "Signature",
    "token": "{d.Signature}",
    "type": "signature",
    "category": "Signing",
    "tooltip": "Electronic signature field"
  },
  {
    "label": "Initials",
    "token": "{d.Initials}",
    "type": "initials",
    "category": "Signing",
    "tooltip": "Electronic initials field"
  },
  {
    "label": "Driver License",
    "token": "{d.ImageBlock1}",
    "type": "imageblock1",
    "category": "Signing",
    "tooltip": "Driver license image upload"
  },
  {
    "label": "Tenant Photo",
    "token": "{d.ImageBlock3}",
    "type": "imageblock3",
    "category": "Signing",
    "tooltip": "Tenant photo upload"
  }
]